import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as PreviewDetail } from "../../../assets/icons/PreviewDetail.svg";
import { ReactComponent as PreviewDelete } from "../../../assets/icons/PreviewDelete.svg";
import Noimage from "../../../assets/icons/Noimage.svg";
import { theme } from "../../../theme";

interface Props {
  imgName?: string;
  folder?: string;
  label?: string;
  isMouseOn?: boolean;
  onRemove?: (e: string) => void;
  onDetail?: (e: string) => void;
  disabled?: boolean;
}
interface StyleProps extends Props {
  isOn: boolean;
  showModify?: boolean;
}
const ImagePreviewBox: React.FC<Props> = ({
  imgName,
  folder,
  label,
  isMouseOn = true,
  onRemove,
  onDetail,
  disabled,
}) => {
  const [isOn, setOn] = useState(false);
  const [src, setSrc] = useState(`${imgName}`);

  useEffect(() => {
    setSrc(`${imgName}`);
  }, [imgName]);
  return imgName ? (
    <BoxContainer
      imgName={imgName}
      showModify={isMouseOn}
      isOn={isOn}
      onClick={
        disabled || isMouseOn === false
          ? () => {
              if (onDetail) onDetail(imgName || "");
            }
          : undefined
      }
      folder={folder}
    >
      {label && <ImageLabel>{label}</ImageLabel>}

      <StyledImg
        className="imageBox"
        src={src}
        onError={() => {
          setSrc(Noimage);
        }}
        alt="이미지"
      />

      <>
        {" "}
        <IconWrapper
          className="icon"
          onClick={() => {
            if (onDetail && imgName) onDetail(imgName);
          }}
        >
          <PreviewDetail />
        </IconWrapper>
        {!disabled && (
          <IconWrapper
            className="icon"
            onClick={() => {
              if (onRemove && imgName) onRemove(imgName);
            }}
          >
            <PreviewDelete />
          </IconWrapper>
        )}
      </>
    </BoxContainer>
  ) : null;
};
export default ImagePreviewBox;
const BoxContainer = styled.div<StyleProps>`
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin: 0px 4px 8px 4px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-size: contain;
  cursor: ${({ isMouseOn }) => (isMouseOn ? "none" : "pointer")};
  background-color: ${({ isOn }) => (isOn ? "black" : theme.colors.gray7)};
  &:hover .icon {
    display: ${({ showModify }) => (showModify ? "flex" : "none")};
  }
  &:hover .imageBox {
    display: ${({ showModify }) => (!showModify ? "flex" : "none")};
  }
  &:hover {
    background-color: ${({ showModify }) =>
      showModify ? "black" : theme.colors.gray9};
  }
`;
const IconWrapper = styled.div`
  margin: 0px 8px;
  display: none;

  cursor: pointer;
  justify-content: center;
  align-items: center;
`;

const StyledImg = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
`;
const ImageLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 2px 8px;
  ${theme.typo.body.r12};
  background-color: ${theme.colors.mainPrimary3};
  color: white;
  position: absolute;
  top: 0;
  left: 0;
`;
